import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
declare let swal: any;
declare var $: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-breedsmanagement',
  templateUrl: './breedsmanagement.component.html',
  styleUrls: ['./breedsmanagement.component.css']
})
export class BreedsmanagementComponent implements OnInit {
  samepageroute = "/dashboard/breedsmanagement";
  returnUrl = "/dashboard/addbreedsmanagement";
  viewurl = "/dashboard/viewbreedsmanagement";
  editurl = "/dashboard/editbreedsmanagement";
  backurl = "/dashboard/mastermodule";
  getlistApi: any;
  farm_user: any;
  loginresponse: any;
  userrole: any;
  dataString: any;
  farm_userrole: any;
  listspeciesname: any = [];
  listbreedid: any = [];
  getfarmsListData: any = [];
  getspeciesListData: any = [];
  isDisabled: boolean = false;
  getBreedsListData: any = [];
  exceldublicatfunarr: any = [];
  exceldublicatfunarrtable: any = [];
  user_id: any;
  farmcodeforvalidation: any;
  dynamicfarmid: any;
  dynamicspeciesid: any;
  speciesloaddata: any = [];
  dynamicbreedid: any;
  loadspeciesValue: any;
  addUrl: any;
  isLoading = false;
  constructor(private router: Router, private commonService: CommonService) { }
  async ngOnInit() {
    // farm list api start
    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
        this.getfarmsListData = res.data;

      })
    // farm list api end
    // species list api start
    this.getlistApi = "/species";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
        this.getspeciesListData = res.data;

      })
    // species list api end
    this.getlistdata()
    $(document).on('click', '.dropdown-menu', function (e) {
      e.stopPropagation();
    });
    $("#dropdwnhideshow > li").click(function () {
      $(this).find("ul.assignments").toggleClass('hide');
    });
  }

  async getlistdata() {
    this.isLoading = true;
    var table;
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.user_id = this.loginresponse.user_id;
    this.userrole = this.loginresponse.read_status;
    this.farmcodeforvalidation = this.loginresponse.user_farm_code;
    this.farm_userrole = this.loginresponse.user_farm_id;
    if (this.userrole == 1) {
      this.isDisabled = true;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    if (this.userrole == 0) {
      this.isDisabled = false;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    this.farm_user = this.farm_userrole;
    if (this.farm_userrole) {
      this.getlistApi = "/breeds/?farm_user=" + this.farm_user;
    }
    else {
      this.getlistApi = "/breeds";
    }


    //this.getlistApi= "/breeds";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.getBreedsListData = res.data;
        $(function () {
          table = $("#myTable").DataTable();
        });
        console.log(res.data);
      })
    $('#speciessearch').on('keyup', function () {
      var inputValue = (<HTMLInputElement>document.getElementById('speciessearch')).value;
      table.search(inputValue).draw();
    });

  }
  //search filter dynamic data load start
  async getfarmvalue(e) {
    this.isLoading = true;
    console.log(e.target.value)
    this.getBreedsListData = []
    $('#myTable').dataTable().fnDestroy();
    this.dynamicfarmid = e.target.value
    var table;
    if (this.farm_userrole) {
      this.getlistApi = "/breeds/filter/all_breeds/?farm_id=" + this.farm_userrole + "&species_id=" + null + "";
    } else {
      this.getlistApi = "/breeds/filter/all_breeds/?farm_id=" + this.dynamicfarmid + "&species_id=" + null + "";
    }
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        setTimeout((res) => {
          this.isLoading = false;
          table = $("#myTable").DataTable();
        }, 500);
        this.getBreedsListData = res.data;
      })
  }
  async getspeciesvalue(e) {

    this.isLoading = true;
    console.log(e.target.value)
    this.getBreedsListData = []
    $('#myTable').dataTable().fnDestroy();
    this.dynamicspeciesid = e.target.value
    var table;
    if (this.farm_userrole) {
      this.getlistApi = "/breeds/filter/all_breeds/?farm_id=" + null + "&species_id=" + this.dynamicspeciesid + "";
    } else {
      this.getlistApi = "/breeds/filter/all_breeds/?farm_id=" + null + "&species_id=" + this.dynamicspeciesid + "";
    }
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        setTimeout((res) => {
          this.isLoading = false;
          table = $("#myTable").DataTable();
        }, 500);
        this.getBreedsListData = res.data;
      })
  }
  //search filter dynamic data load start

  addbreedsmanagement() {
    this.router.navigate([this.returnUrl]);
  }
  viewbreedsmanagement(e) {
    console.log(e.target.id);
    sessionStorage.setItem('breedsId', e.target.id);
    this.router.navigate([this.viewurl]);
  }
  editbreedsmanagement(e) {
    console.log(e.target.id);
    sessionStorage.setItem('breedsId', e.target.id)
    this.router.navigate([this.editurl]);
  }
  backtomastermodule() {
    this.router.navigate([this.backurl]);
  }
  sweetdelete(e) {
    Swal.fire({
      title: 'Are you sure you want to delete the Breeds record ?',
      //text: 'You will not be able to recover this file!',  
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.value) {
        var deleteurl = "/breeds/" + e.target.id;
        (await this.commonService.deleteApi(deleteurl)).subscribe(
          res => {
            Swal.fire(
              'Deleted!',
              'The Breeds record has been deleted successfully',
              'success'
            );
            let currentUrl = this.samepageroute;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });
          })

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'The Breeds record has not been deleted',
          'error'
        )
      }
    })
  }
  //bulk upload import data from excel start

  async importbulkdatafromexcel(ev) {

    console.log('test');
    console.log(ev);
    this.getspeciesListData;
    var uniquerSpeciesformarray = [];
    var uniquespeciesarray = [];
    var sweetalert = [];
    var breedfarmname_specisid_breedname = [];
    var bname_speciesname_bid_fname = [];
    var breedfarmname_specisname_breedid = [];
    console.log(this.getfarmsListData)
    for (var i = 0; i < this.getfarmsListData.length; i++) {
      var farmname1 = String(this.getfarmsListData[i].tnfr_code).trim().toLowerCase();
      uniquerSpeciesformarray.push(farmname1);
      console.log(uniquerSpeciesformarray)
    }
    for (var i = 0; i < this.getspeciesListData.length; i++) {
      var speciesname1 = String(this.getspeciesListData[i].speciesID).trim().toLowerCase();
      uniquespeciesarray.push(speciesname1);
      console.log(uniquespeciesarray)
    }

    for (var i = 0; i < this.getBreedsListData.length; i++) {
      var getval = String(this.getBreedsListData[i].farm_code).trim().toLowerCase();
      var speciesname = String(this.getBreedsListData[i].species_code).trim().toLowerCase();
      //var breedname=this.getBreedsListData[i].name
      var breedid = String(this.getBreedsListData[i].breedID).trim().toLowerCase();
      this.listspeciesname.push(speciesname);
      this.listbreedid.push(breedid);
      var getfarmname = getval.split(",");
      console.log(getfarmname);
      for (var j = 0; j < getfarmname.length; j++) {
        var farmname = getfarmname[j];
        console.log(farmname);
        //uniquerSpeciesformarray.push(farmname);
        // breedfarmname_specisid_breedname.push(farmname+'_'+speciesname+'_'+breedname);
        breedfarmname_specisname_breedid.push(farmname + '_' + speciesname + '_' + breedid);
        //  bname_speciesname_bid_fname.push(farmname+'_'+speciesname+'_'+breedname+'_'+breedid)
      }
    }

    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var uploadexcelarray = Object.values(jsonData)[0];
      this.dataString = { data: uploadexcelarray }
      //        let value:any=dataString;
      console.log(this.dataString);
      console.log(this.dataString.data);

      //      var excelUniquecheck=[];
      var excelFnameSnmeBname = [];
      var excelfarmuniquename = [];
      var excelFnameSnmeBid = [];
      var excelFnameSnameBnameBId = [];
      var wrongfarmid = [];
      var excelspeciesuniquename = [];
      if (this.farm_userrole) {
        for (var i = 0; i < this.dataString.data.length; i++) {
          if (this.dataString.data[i]["Farm id"].trim().toLowerCase() == this.farmcodeforvalidation.trim().toLowerCase()) {
            var farmname = String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
            var speciesname = String(this.dataString.data[i]["Species id"]).trim().toLowerCase()
            var breedname = String(this.dataString.data[i].breedID).trim().toLowerCase()
            //excelFnameSnmeBname.push(this.dataString.data[i].farm_name+'_'+this.dataString.data[i].species_name+'_'+this.dataString.data[i].name);
            excelFnameSnmeBid.push(farmname + '_' + speciesname + '_' + breedname);
            // excelFnameSnameBnameBId.push(this.dataString.data[i].farm_name+'_'+this.dataString.data[i].species_name+'_'+this.dataString.data[i].name+'_'+this.dataString.data[i].breedID);
            excelfarmuniquename.push(farmname);
            excelspeciesuniquename.push(speciesname);
          }
          else {
            wrongfarmid.push(this.dataString.data[i]["Farm id"].trim().toLowerCase())
            console.log(wrongfarmid)
          }
        }
        if (wrongfarmid.length !== 0) {
          sweetalert.push("Entered Incorrect Farm Id")
        }
      }
      if (!this.farm_userrole) {
        for (var i = 0; i < this.dataString.data.length; i++) {
          var farmname = String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
          var speciesname = String(this.dataString.data[i]["Species id"]).trim().toLowerCase()
          var breedname = String(this.dataString.data[i].breedID).trim().toLowerCase()
          //excelFnameSnmeBname.push(this.dataString.data[i].farm_name+'_'+this.dataString.data[i].species_name+'_'+this.dataString.data[i].name);
          excelFnameSnmeBid.push(farmname + '_' + speciesname + '_' + breedname);
          // excelFnameSnameBnameBId.push(this.dataString.data[i].farm_name+'_'+this.dataString.data[i].species_name+'_'+this.dataString.data[i].name+'_'+this.dataString.data[i].breedID);
          excelfarmuniquename.push(farmname);
          excelspeciesuniquename.push(speciesname);
        }
      }
      //unique farm check start

      var differentfarmdata = [];

      // var difference = [];
      console.log(excelfarmuniquename)
      for (var i = 0; i < excelfarmuniquename.length; i++) {
        if ($.inArray(excelfarmuniquename[i], uniquerSpeciesformarray) == -1) {
          differentfarmdata.push(excelfarmuniquename[i]);
          console.log(excelfarmuniquename[i])
        }
      }
      console.log(differentfarmdata)
      var result = "";
      if (differentfarmdata) {
        for (var i = 0; i < differentfarmdata.length; i++) {
          result += "Farm Id '" + differentfarmdata[i] + "' doesn't exist<br>"
          console.log(differentfarmdata);
        }
      }
      if (result) {
        // Swal.fire("Wrong Farm Selection",result);
        sweetalert.push(result)
      }
      //unique farm check end
      //unique species check start
      var differentspeciesdata = [];
      for (var i = 0; i < excelspeciesuniquename.length; i++) {
        if ($.inArray(excelspeciesuniquename[i], uniquespeciesarray) == -1) {
          differentspeciesdata.push(excelspeciesuniquename[i]);
        }
      }
      console.log(differentspeciesdata)
      var resultspecies = "";
      if (differentspeciesdata) {
        for (var i = 0; i < differentspeciesdata.length; i++) {
          resultspecies += "Species Id '" + differentfarmdata[i] + "' doesn't exist<br>"
          console.log(differentspeciesdata);
        }
      }
      if (resultspecies) {
        // Swal.fire("Wrong Farm Selection",resultspecies);
        sweetalert.push(resultspecies)
      }
      //unique species check end

      //console.log(excelUniquecheck);
      //dublicate species id entry check in excel with farm id
      //  this.exceldublicatevaluecheck(excelFnameSnmeBname);
      //console.log(uniquerSpeciesformarray);
      /*console.log(this.exceldublicatfunarr);
      var result1 = "";
      if(this.exceldublicatfunarr){
        for(var i=0;i<this.exceldublicatfunarr.length;i++){
         var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
         var farmnamedublicate=getduplicatevalue[0];
         var speciesnamedublicate=getduplicatevalue[1];
         var breednamedublicate=getduplicatevalue[2];
        result1 +="Farm Name "+farmnamedublicate+" Species Name "+speciesnamedublicate+" Bread Name "+breednamedublicate+"<br>"
        console.log(this.exceldublicatfunarr);
      }
      
      }
      if(result1){
       // Swal.fire("Duplicate Values",result1);
        sweetalert.push(result1)
      }*/

      //dublicate species id entry check in excel with farm id
      this.exceldublicatevaluecheck(excelFnameSnmeBid);
      //console.log(uniquerSpeciesformarray);
      console.log(this.exceldublicatfunarr);
      var resultbreedid = "";
      if (this.exceldublicatfunarr) {
        for (var i = 0; i < this.exceldublicatfunarr.length; i++) {
          var getduplicatevalue = this.exceldublicatfunarr[i].split('_');
          var farmnamedublicate = getduplicatevalue[0];
          var speciesnamedublicate = getduplicatevalue[1];
          var breednamedublicate = getduplicatevalue[2];
          resultbreedid += "Breed Id '" + breednamedublicate + "' entered multiple times<br>"
          console.log(this.exceldublicatfunarr);
        }

      }
      if (resultbreedid) {
        // Swal.fire("Duplicate Values",resultbreedid);
        sweetalert.push(resultbreedid)
      }

      /*this.exceldublicatevaluecheck(excelFnameSnameBnameBId);
      console.log(this.exceldublicatfunarr);
      var result2 = "";
      if(this.exceldublicatfunarr){
        for(var i=0;i<this.exceldublicatfunarr.length;i++){
         var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
         var farmnamedublicate=getduplicatevalue[0];
         var speciesnamedublicate=getduplicatevalue[1];
         var breednamedublicate=getduplicatevalue[2];
         var breediddublicate=getduplicatevalue[3];
        result2 +="Farm Name "+farmnamedublicate+" Species Name "+speciesnamedublicate+" Bread Name "+breednamedublicate+" Bread Id "+breediddublicate+"<br>"
        console.log(this.exceldublicatfunarr);
      }
      
      }
      if(result2){
        //Swal.fire("Duplicate Values",result2);
        sweetalert.push(result2)
      }*/
      //dublicate species id entry check in excel with farm id end
      //console.log(specisfarmnamespecisid)
      //console.log(excelUniquecheck)
      //dublicate species id,breed id entry check in list table with farm id start
      //var exceltablebreedtablecheck=[];
      /*this.exceldublicatevaluecheckintable(excelFnameSnameBnameBId,breedfarmname_specisid_breedname)
      
      console.log(this.exceldublicatfunarrtable);
      //console.log(uniquerSpeciesformarray);
      var result3 ="";
      if(this.exceldublicatfunarrtable){
        for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
         var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
         var farmnamedublicate3=getduplicatevalue[0];
         var speciesnamedublicate3=getduplicatevalue[1];
         var breednamedublicate3=getduplicatevalue[2];
         result3 +="Farm Name "+farmnamedublicate3+" Species Name "+speciesnamedublicate3+" Bread Name "+breednamedublicate3+"<br>"
         console.log(this.exceldublicatfunarr);
      }
      }
      if(result3){
       // Swal.fire("Same SpeciesId Entry",result3);
        sweetalert.push(result3)
      }*/

      this.exceldublicatevaluecheckintable(excelFnameSnmeBid, breedfarmname_specisname_breedid)

      console.log(this.exceldublicatfunarrtable);
      //console.log(uniquerSpeciesformarray);
      var resultbreedid = "";
      if (this.exceldublicatfunarrtable) {
        for (var i = 0; i < this.exceldublicatfunarrtable.length; i++) {
          var getduplicatevalue = this.exceldublicatfunarrtable[i].split('_');
          var farmnamedublicate3 = getduplicatevalue[0];
          var speciesnamedublicate3 = getduplicatevalue[1];
          var breediddublicate3 = getduplicatevalue[2];
          resultbreedid += "Breed Id '" + breediddublicate3 + "' entered multiple times<br>"
          console.log(this.exceldublicatfunarr);
        }
      }
      if (resultbreedid) {
        //Swal.fire("Duplicate farm value",resultbreedid);
        sweetalert.push(resultbreedid)
      }
      //second data table check
      /*this.exceldublicatevaluecheckintable(excelFnameSnmeBname,bname_speciesname_bid_fname)
      console.log(this.exceldublicatfunarrtable);
      //console.log(uniquerSpeciesformarray);
      var result4 = "";
      if(this.exceldublicatfunarrtable){
        for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
         var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
         var farmnamedublicate4=getduplicatevalue[0];
         var speciesnamedublicate4=getduplicatevalue[1];
         var breednamedublicate4=getduplicatevalue[2];
         var breediddublicate4=getduplicatevalue[3];
         result4 +="Farm Name "+farmnamedublicate4+" Species Name "+speciesnamedublicate4+" Bread Name "+breednamedublicate4+" Breed Id "+breediddublicate4+"<br>"
         console.log(this.exceldublicatfunarr);
      }
      }
      if(result4){
       // Swal.fire("Same SpeciesId Entry",result4);
        sweetalert.push(result4)
      }*/
      //dublicate species id and breed entry check in list table with farm id end
      var finalvalidatevalue = '';
      for (var i = 0; i < sweetalert.length; i++) {
        finalvalidatevalue += sweetalert[i] + "<br>";
      }
      if (finalvalidatevalue) {
        Swal.fire("Duplicate values", finalvalidatevalue);
        let currentUrl = this.samepageroute;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      } else {
        var breedsbulkdata = []
        for (var i = 0; i < this.dataString.data.length; i++) {
          var updatestatus = this.dataString.data[i].Status.toLowerCase();
          if (updatestatus == "active") {
            this.dataString.data[i].Status = 1
          } else {
            this.dataString.data[i].Status = 0
          }
          var obj = this.dataString.data[i];
          Object.assign(obj, { cby: this.user_id });
          Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
          breedsbulkdata.push(obj);
        }
        console.log(breedsbulkdata)
        this.addUrl = "/breeds/bulk";
        (await this.commonService.postApi(this.addUrl, breedsbulkdata)).subscribe(
          data => {
            alert(data.message);
          });
        let currentUrl = this.samepageroute;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });

      }

      /* this.addUrl = "/species";
     (await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
       data => {
           alert(data.message);
       });*/

      // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");

    }
    reader.readAsBinaryString(file);
  }
  //bulk upload import data from excel end......................
  exceldublicatevaluecheck(excelFnameSnmeBname) {
    const arry = excelFnameSnmeBname;
    const toFindDuplicates = arry => arry.filter((item, index) => arry.indexOf(item) !== index)
    const duplicateElementa = toFindDuplicates(arry);
    this.exceldublicatfunarr = duplicateElementa;
  }
  exceldublicatevaluecheckintable(excelFnameSnmeBname, breedfarmname_specisname_breedid) {
    console.log(excelFnameSnmeBname)
    console.log(breedfarmname_specisname_breedid)
    for (var i = 0; i < excelFnameSnmeBname.length; i++) {
      if ($.inArray(excelFnameSnmeBname[i], breedfarmname_specisname_breedid) !== -1) {
        this.exceldublicatfunarrtable.push(excelFnameSnmeBname[i]);
      }
    }
  }

  exportbreeds() {
    var downloadtabledata = this.getBreedsListData;
    var resultarry = downloadtabledata.map((ele) => {
      if (ele.status == 1) {
        var statusc = "Active";
      } else {
        var statusc = "Inactive";
      }
      return { "Farm name": ele.farm_name, "Species name": ele.species_name, "Breed name": ele.name, "Breed ID": ele.breedID, "Status": statusc }
    })
    console.log(resultarry);
    this.exportAsExcelFile(resultarry, 'breeds');
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  currentpageroute() {
    let currentUrl = this.samepageroute;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

}

